import Util from '../utils/util.js';
import { webformIsDisabled } from '../utils/webform.js';
import { preserveUnsavedState } from '../utils/beforeunload.js';

if (window.site_type && window.site_type === 'afri') {

    /**********************************************************
     *                 Background module
     */
    function onReadyModuleBackground() {
    }

    /**********************************************************
     *                 Participants module
     */
    function onReadyModuleParticipants() {
        $('td.webform_table_element_created_in_reporting_period_id').each(function() {
            let created_in_rp_id = $(this).html();
            if (created_in_rp_id != current_rp_id) {
                $(this).parent('tr').find('input[value="Delete"]').parent('td').html(
                    '<span ' +
                    'class="is-tooltip btn btn-default btn-xs" ' +
                    'data-toggle="tooltip" ' +
                    'title="This participant was<br>imported from a<br>prior reporting period" ' +
                    '>' +
                    'Imported</span>');
            }
        });
        $(".is-tooltip").tooltip({
            placement: 'left',
            viewport: 'table.webform_multiple',
            html: true
        });
        $('.webform_table_element_created_in_reporting_period_id').remove();

        let needsUpdatedCount = 0;
        $('td.webform_table_element_is_draft').each(function() {
            let is_draft = $(this).html();
            if (is_draft == 0) {
                $(this).html('<span class="glyphicon glyphicon-ok text-success center-block"></span>');
            } else {
                $(this).html('Must Update');
                needsUpdatedCount++;
            }
        });
        if (needsUpdatedCount) {
            $('#_webform_action\\[submit_all\\]').prop('disabled', true);
            $('#complete_instructions').html(
                'You cannot complete this module until you have updated all participants from the initial reporting period.'
            );
        }
    }

    /**********************************************************
     *                 Participants subform
     */
    function onReadyModuleParticipantsSubform() {
        if (webformIsDisabled()) {
            $('#search_participants').remove();
            return;
        }

        // Handle search
        let id = $('.webform input[name="id"]').val();
        if (id) {
            $('#search-section').removeClass('in');
        } else {
            $('#search-section').addClass('in');
        }

        $('#search_participants').typeahead({}, {
            name: 'search_participants',
            displayKey: 'name',
            source: function(query, sync, async) {
                query = Util.urlEncode(query);
                //Check for blank queries.
                if (query != '') {
                    $.ajax(window['public_path'] + '/participants/search/' + query, {dataType: 'json'})
                        .success(function (result) {
                            async(result);
                        });
                }
            },
            templates: {
                suggestion: function (t) {
                    return '<div><div class="name">'+(t.name||'')+'</div><div class="email">'+(t.email||'')+'</div></div>';
                }
            }
        }).on('typeahead:select typeahead:autocomplete', function($e, datum) {
            Util.setFromJson(datum);
        });

        // Show message if in edit mode and there is no delet button showing
        let isEdit = window['route_id'];
        if (isEdit && ! $('.webform-delete').length) {
            $('.webform_element_type_actions > div').append(
                '<div class="alert alert-info" style="margin-top:10px">' +
                'You may not delete this participant since they already have a user account. ' +
                'Please mark them as not having Worked on Project instead if desired.</div>');
        }
    }

    /**********************************************************
     *                 Publications module
     */
    function publicationArrangeFields(type)
    {
        if (type == 'book_chapter') {
            $('#first_page_or_elocation_id').parents('.form-group').insertBefore($('#book_edition').parents('.form-group'));
        } else {
            $('#first_page_or_elocation_id').parents('.form-group').insertBefore($('#publication_date').parents('.form-group'));
        }
        if ($.inArray(type,['conference_paper_or_proceeding','presentation','other']) !== -1) {
            $('#publication_date').parents('.form-group').insertAfter($('#status').parents('.form-group'));
        } else {
            $('#publication_date').parents('.form-group').insertBefore($('#publication_location').parents('.form-group'));
        }
    }

    function publicationModifyFields(type)
    {
        // Set title (field #2)
        switch (type) {
            case "journal_article":
                $("label[for='title']").text('Article Title');
                break;
            case "book":
            case "book_chapter":
                $("label[for='title']").text('Book Title');
                break;
            case "conference_paper_or_proceeding":
            case "presentation":
                $("label[for='title']").text('Paper or Presentation Title');
                break;
            case "other":
                $("label[for='title']").text('Publication Title');
                break;
            default:
                $("label[for='title']").text('Title');
                break;
        }

        // Set authors (field #4)
        switch (type) {
            case "journal_article":
                $("label[for='contactlist']").text('Article Author(s)');
                break;
            case "book_chapter":
                $("label[for='contactlist']").text('Chapter Author(s)');
                break;
            case "website":
                $("label[for='contactlist']").text('Web Site Author(s)');
                break;
            default:
                $("label[for='contactlist']").text('Author(s)');
                break;
        }

        // Set help tip for authors field based on type
        switch (type) {
            case "journal_article":
            case "book":
            case "book_chapter":
            case "thesis_or_dissertation":
            case "conference_paper_or_proceeding":
            case "other":
                $(".webform_element_authors .help-block").html('The names of the authors as they appear in the citation. ' +
                    '<strong><u>Please use JFP format:</u> Johnson, B. H., L. Smith, and M. R. Jones.</strong>');
                $('#authors').attr('placeholder', 'E.g. Johnson, B. H., L. Smith, and M. R. Jones');
                break;
            case "presentation":
                $(".webform_element_authors .help-block").html('The names of the authors as they appear in the citation. ' +
                '<strong><u>Please use Chicago Manual format:</u> Max R. Jones, Buster H. Johnson, and Lucy Smith.</strong>');
                $('#authors').attr('placeholder', 'E.g. Max R. Jones, Buster H. Johnson, and Lucy Smith');
                break;
            case "website":
                $(".webform_element_authors .help-block").html('The names of the authors who contributed to the website. ' +
                '<strong><u>Please use Chicago Manual format:</u> Max R. Jones, Buster H. Johnson, and Lucy Smith.</strong>');
                break;
            default:
                $(".webform_element_authors .help-block").text('The names of the authors as they appear in the citation.');
                $('#authors').attr('placeholder', '');
                break;
        }

        // Disable several of publication status the options for the Website publication type
        switch(type) {
            case "website":
                $('#status option[value="publications_status----epublished_only"]').attr('disabled', 'disabled');
                $('#status option[value="publications_status----epublished_awaiting_print_publication"]').attr('disabled', 'disabled');
                $('#status option[value="publications_status----accepted"]').attr('disabled', 'disabled');
                $('#status option[value="publications_status----submitted"]').attr('disabled', 'disabled');
                break;
            default:
                $('#status option[value="publications_status----epublished_only"]').removeAttr('disabled');
                $('#status option[value="publications_status----epublished_awaiting_print_publication"]').removeAttr('disabled');
                $('#status option[value="publications_status----accepted"]').removeAttr('disabled');
                $('#status option[value="publications_status----submitted"]').removeAttr('disabled');
                break;
        }

        // Set volume (field #13)
        switch (type) {
            case "journal_article":
                $("label[for='volume']").text('Journal Volume');
                break;
            case "book":
            case "book_chapter":
                $("label[for='volume']").text('Book Volume');
                $(".webform_element_volume .help-block").show();
                break;
            default:
                $("label[for='volume']").text('Volume');
                $(".webform_element_volume .help-block").hide();
                break;
        }

        // Set publication_date (field #16) and publication_location (field #18)
        switch (type) {
            case "conference_paper_or_proceeding":
            case "presentation":
                $("label[for='publication_date']").text('Conference Start Date');
                $("label[for='publication_location']").text('Conference Location');
                $(".webform_element_publication_location .help-block").text('The city, state, and country where the conference was held.');
                $(".webform_element_publication_date, .webform_element_publication_location").removeClass('show_if_published');
                $(".webform_element_publication_date, .webform_element_publication_location").show();
                break;
            case "website":
                $("label[for='publication_date']").text('Date Launched');
            default:
                $("label[for='publication_date']").text('Publication Date');
                $("label[for='publication_location']").text('Publication Location');
                $(".webform_element_publication_location .help-block").text('The city and country of publication.');
                $(".webform_element_publication_date, .webform_element_publication_location").addClass('show_if_published');
                break;
        }

        // Set publication_identifier field attributes (for websites)
        switch (type) {
            case "website":
                $("label[for='publication_identifier']").text('URL');
                $(".webform_element_publication_identifier .help-block").html('URL of the website.');
                $('#publication_identifier').attr('placeholder', 'E.g. http://www.example.com/');
                break;
            default:
                $("label[for='publication_identifier']").text('Publication Identifier');
                $(".webform_element_publication_identifier .help-block").html('Optional unless published.');
                $('#publication_identifier').attr('placeholder', '');
                break;
        }

    }

    function onReadyModulePublications() {
            let jType = $('#type');
        jType.change(function() {
            publicationArrangeFields(Util.makeBareSlug(jType.val()));
            publicationModifyFields(Util.makeBareSlug(jType.val()));
            Util.setupLabelPositionAdjuster();
        });
        jType.change();

        let jWebform = $('.webform');
        $('.show_if_accepted, .show_if_awaiting, .show_if_published', jWebform).css('display', 'none');
        $('#status').change(function() {
            jWebform
                .addClass('not_published')
                .removeClass('published')
                .removeClass('awaiting')
                .removeClass('accepted');
            switch (Util.makeBareSlug($('#status').val())) {
                case 'published': // published
                case 'epublished_only':
                case 'epublished_awaiting_print_publication':
                    jWebform
                        .addClass('published')
                        .removeClass('not_published');
                    break;
                case 'awaiting_publication': // awaiting
                    jWebform.addClass('awaiting');
                    break;
                case 'accepted': // accepted
                    jWebform.addClass('accepted');
                    break;
            }
        });
        $('#status').change();

        // Assign completion handles to the designated fields.
        Util.assignCompletion(['title', 'chapter_title'], 'publications')
    }

    /**********************************************************
     *                 IP module
     */
    function ipModifyFields(type)
    {
        // Set title (field #1)
        switch (type) {
            case "publications_type----patent":
                $("label[for='title']").text('Patent Title');
                break;
            case "publications_type----invention":
                $("label[for='title']").text('Invention Title');
                break;
            case "publications_type----license":
                $("label[for='title']").text('License Title');
                break;
            default:
                $("label[for='title']").text('Title');
                break;
        }

        // Set description (field #3)
        switch (type) {
            case "publications_type----patent":
                $("label[for='description']").text('Patent Abstract');
                break;
            case "publications_type----invention":
                $("label[for='description']").text('Invention Description');
                break;
            default:
                $("label[for='description']").text('Description');
                break;
        }

        // Set status (field #5)
        switch (type) {
            case "publications_type----license":
                $("label[for='status']").text('License Status');
                break;
            default:
                $("label[for='status']").text('Status');
                break;
        }
    }

    function onReadyModuleIP() {
        let jType = $('#type');
        jType.change(function() {
            ipModifyFields(jType.val());
            Util.setupLabelPositionAdjuster();
        });
        jType.change();
        $('#status').change(function() {
            switch ($('#status').val()) {
                case 'ip_status----granted': // granted
                    $('.webform').removeClass('not_granted');
                    break;
                default:
                    $('.webform').addClass('not_granted');
                    break;
            }
        }).change();

        $('#invention_disclosure').change(function() {
            switch ($('#invention_disclosure').val()) {
                case "1": // disclosure
                    $('.webform').removeClass('not_disclosure');
                    break;
                default:
                    $('.webform').addClass('not_disclosure');
                    break;
            }
        }).change();

        // Assign completion handles to the designated fields.
        Util.assignCompletion(['title'], 'ip')
    }

    function setupModule(module_slug, is_subform) {
        if (module_slug === 'background') { onReadyModuleBackground() }
        if (module_slug === 'participants' && is_subform) { onReadyModuleParticipantsSubform() }
        if (module_slug === 'participants') { onReadyModuleParticipants() }
        if (module_slug === 'publications') { onReadyModulePublications() }
        if (module_slug === 'ip') { onReadyModuleIP() }

        $('.webform .webform_element_type_checkboxes:not(.single) > label').append('<br><span class="apply">(select all that apply)</span>');

        Util.setupLabelPositionAdjuster(); // Must be after module loaders, as they may change label contents
    }

    /**********************************************************
     *                 OnReady handler
     */
    $(document).ready(function() {
        if (typeof window['route_module_slug'] !== 'undefined') {
            let module_slug = window['route_module_slug'];
            let is_subform = module_slug == window['route_subform_element'];
            preserveUnsavedState(() => setupModule(module_slug, is_subform));
        }
    });
}
